import React from "react";
import axios from "../../../../../axios";
import { toast } from "react-toastify";
import { Box, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";

const AssessPopupBox = ({
  publicPreRead_id,
  setIsDeactivated,
  setDeactivatePopup,
}) => {
  const handleStatus = async (e) => {
    e.preventDefault();
    const changeStatus = { status: "draft" };

    try {
      const res = await axios.post(
        `/api/v1/homework/preRead/updateStatus/${publicPreRead_id}`,
        changeStatus
      );

      if (res) {
        toast.success("Deactivated Successfully");
        setIsDeactivated(true);
        setDeactivatePopup?.();
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    } finally {
      setDeactivatePopup(false);
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 180,
      }}
    >
      <Button
        variant="outlined"
        color="warning"
        startIcon={<BlockIcon />}
        fullWidth
        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        onClick={handleStatus}
      >
        Deactivate
      </Button>
    </Box>
  );
};

export default AssessPopupBox;
